import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { SizeAttributeInputControl } from '@gift/attributes-size-website/SizeAttributeInputControl';
import { SizeAttributeOptions } from '@gift/attributes-size-core/SizeAttributeOptions';
import { SizeAttributeInput } from '@gift/attributes-size-core/SizeAttributeInput';

export const sizeAttributeWebsitePlugin: WebsitePlugin.Variable<SizeAttributeOptions, SizeAttributeInput> = {
    pluginId: 'size-attribute',
    InputControl: SizeAttributeInputControl,
    toFfCanvas: () => []
};